import React, { lazy, Suspense, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Spinner } from 'reactstrap';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Font } from '@react-pdf/renderer';
import StoreProvider from './Store/StoreProvider';
import FrontNav from './Reports/Components/FrontNav';
import './App.scss';

/* eslint-disable */

const registerFont = () => {
    Font.register({ family: 'Playfair',
        fonts: [
            { src: 'https://bond-skills-reports-resources.s3.ap-southeast-2.amazonaws.com/fonts/PlayfairDisplay-BlackItalic.ttf', fontWeight: 'black', fontStyle: 'italic' }
        ] });
    Font.register({ family: 'Interstate',
        fonts: [
            { src: 'https://bond-skills-reports-resources.s3.ap-southeast-2.amazonaws.com/fonts/InterstateLight.otf' },
            { src: 'https://bond-skills-reports-resources.s3.ap-southeast-2.amazonaws.com/fonts/InterstateLightItalic.otf', fontStyle: 'italic' },
            { src: 'https://bond-skills-reports-resources.s3.ap-southeast-2.amazonaws.com/fonts/InterstateBold.otf', fontWeight: 'bold' },
            { src: 'https://bond-skills-reports-resources.s3.ap-southeast-2.amazonaws.com/fonts/InterstateBlack.otf', fontWeight: 'black' }
        ] });
    Font.registerHyphenationCallback(word => [word]);
};

const App = () => {
    useEffect(() => {
        registerFont();
    }, []);

    const CertificateReport = {
        Render: lazy(() => import('./Reports/Certificate/Pages/Render'))
    };
    const PortfolioReport = {
        Filter: lazy(() => import('./Reports/Portfolio/Pages/Filter')),
        Render: lazy(() => import('./Reports/Portfolio/Pages/Render'))
    };
    const NavRouter = withRouter(() => <FrontNav />);
    return <Sentry.ErrorBoundary fallback={<>An error has occured</>} showDialog>
        <StoreProvider>
            <Suspense fallback={<div className='spinnerDiv'>
                <Spinner />
                Downloading Experiences
            </div>}
            >
                <Router>
                    <NavRouter />
                    <Switch>
                        <Route path='/portfolio' exact><Redirect to='/portfolio/filter' /></Route>
                        <Route path='/portfolio/filter'><PortfolioReport.Filter /></Route>
                        <Route path='/portfolio/view'><PortfolioReport.Render /></Route>

                        <Route path='/certificate' exact><Redirect to='/certificate/view' /></Route>
                        <Route path='/certificate/view'><CertificateReport.Render /></Route>
                    </Switch>
                </Router>
            </Suspense>
        </StoreProvider>
    </Sentry.ErrorBoundary>
};

export default App;
